export default __webpack_public_path__ + "static/media/Back Upper.caa76925.jpg";